module.exports = __webpack_public_path__ + "img/bg_successfully_hero.7f12c76.svg";